import { gql } from '@apollo/client';

import { LIST_FOOD_COMPONENT_BY_RANGE_RESPONSE_FIELDS } from './fragments';

export const LIST_FOOD_COMPONENT_BY_RANGE_QUERY = gql`
  ${LIST_FOOD_COMPONENT_BY_RANGE_RESPONSE_FIELDS}
  query ListFoodComponentByRange(
    $kitchen: Kitchen
    $startDate: String
    $endDate: String
    $limit: Int
    $next: String
    $filters: ListFoodComponentByRangeFilters
  ) {
    listFoodComponentByRange(
      kitchen: $kitchen
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      next: $next
      filters: $filters
    ) {
      ...ListFoodComponentByRangeResponseFields
    }
  }
`;
